// extracted by mini-css-extract-plugin
export default {"page":"admin_page__sJajD","container":"admin_container__u6eJe","footer":"admin_footer__xdih+"};